<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('whiteLabel')})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <Card
                :title="$t(title)"
                is-dark
                mode="default"
                class="uk-height-1-1">
                <Description v-if="description" :text="$t(description)" />

                <span v-on:click="addNewLink()">
                    <Button mode="primary">
                        {{
                            $t('x.add', {
                                x: $t('link'),
                            })
                        }}
                    </Button>
                </span>
                <div class="uk-margin-bottom" />

                <div v-if="inputFields.length === 0">
                    <Translate
                        translation-key="none.x"
                        :parameter="{x: $t('links')}" />
                </div>

                <span
                    v-for="(inputField, key) in inputFields"
                    :key="key + inputField.name">
                    <div class="uk-grid-small uk-grid-match" uk-grid>
                        <div class="uk-width-expand">
                            <TextField
                                v-model="inputField.value"
                                :autocomplete="inputField.autocomplete"
                                :autofocus="inputField.autofocus"
                                :field-key="key"
                                :hasPasswordMeter="inputField.hasPasswordMeter"
                                :icon="getIcon(inputField.value)"
                                :is-optional="inputField.optional"
                                :label="inputField.label"
                                :name="inputField.name"
                                :options="inputField.options"
                                :rules="inputField.rules"
                                :steps="inputField.steps"
                                :type="inputField.type"
                                :on-enter="actionUpdate"
                                :validate="validationTrigger"
                                @setValid="setValid" />
                        </div>

                        <div class="uk-width-auto">
                            <div class="delete-icon">
                                <LabelWithError
                                    :label="$t('delete')"
                                    class="uk-invisible" />
                                <span
                                    :uk-tooltip="
                                        'title:' +
                                        $t('x.delete', {
                                            x: $t('link'),
                                        })
                                    "
                                    class="cursor-pointer"
                                    v-on:click="removeLink(key)">
                                    <Icon icon="trash" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="key < inputFields.length - 1"
                        class="uk-margin-bottom" />
                </span>

                <div class="uk-margin-medium-bottom" />
                <Button
                    :action="actionUpdate"
                    :is-loading="loading"
                    :text="$t('x.save', {x: $t(title)})"
                    has-action
                    is-large
                    is-max
                    mode="primary" />

                <div v-if="error" class="uk-margin-medium-bottom" />
                <ErrorMessage :error="error" />

                <div v-if="success" class="uk-margin-medium-bottom" />
                <SuccessMessage
                    :success="success"
                    :message="$t('x.changes.saved', {x: $t(title)})" />
            </Card>
        </span>
    </span>
</template>

<script>
import SuccessMessage from '@/components/generic/SuccessMessage.vue';
import Description from '@/components/Description.vue';
import Button from '@/components/generic/Button.vue';
import TextField from '@/components/generic/TextField.vue';
import Card from '@/components/generic/Card.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import LabelWithError from '@/components/generic/LabelWithError.vue';
import Translate from '@/components/Translate.vue';

export default {
    name: 'ClickAndBuyLinksForm',
    components: {
        Translate,
        LabelWithError,
        Icon,
        ErrorMessage,
        Card,
        TextField,
        Button,
        Description,
        SuccessMessage,
    },
    props: {
        text: Array,
        disabled: Boolean,
    },
    created() {
        if (this.text && this.text.length > 0) {
            for (let i = 0, j = this.text.length; i < j; i++) {
                const text = this.text[i];

                this.inputFields.push({
                    value: text,
                    valid: true,

                    name: 'link',
                    label: 'link',
                    rules: 'required',
                });
            }
        }
    },
    data() {
        return {
            title: 'links',
            description: '',

            loading: false,
            success: false,
            error: null,

            validationTrigger: 0,
            inputFields: [],
        };
    },
    methods: {
        getIcon(value) {
            if (!value) {
                return 'social';
            }

            const icons = [
                '500px',
                'android',
                'android-robot',
                'apple',
                'behance',
                'bluesky',
                'discord',
                'dribbble',
                'etsy',
                'facebook',
                'flickr',
                'foursquare',
                'github',
                'github-alt',
                'gitter',
                'google',
                'instagram',
                'joomla',
                'linkedin',
                'mastodon',
                'microsoft',
                'pinterest',
                'reddit',
                'signal',
                'soundcloud',
                'telegram',
                'threads',
                'tiktok',
                'tripadvisor',
                'tumblr',
                'twitch',
                'uikit',
                'vimeo',
                'whatsapp',
                'wordpress',
                'x',
                'xing',
                'yelp',
                'yootheme',
                'youtube',
            ];

            const lowerValue = value.toLowerCase();

            for (const icon of icons) {
                if (!lowerValue.includes('http') && lowerValue.includes('@')) {
                    return 'mail';
                }

                if (
                    !lowerValue.includes('http') &&
                    this.isNumericPhoneNumber(value)
                ) {
                    return 'receiver';
                }

                if (
                    lowerValue.includes('http') &&
                    lowerValue.includes(icon.toLowerCase())
                ) {
                    return icon;
                }
            }

            return 'social';
        },
        isNumericPhoneNumber(str) {
            return /^\+?\d[\d\s]*$/.test(str.trim());
        },
        addNewLink() {
            this.inputFields.push({
                value: '',
                valid: false,

                name: 'link',
                label: 'link',
                rules: 'required',
            });
        },
        removeLink(key) {
            this.inputFields.splice(key, 1);
        },
        setValid(valid, fieldKey) {
            this.success = false;
            this.inputFields[fieldKey].valid = valid;
        },
        actionUpdate() {
            this.validationTrigger++;

            for (let i = 0, j = this.inputFields.length; i < j; i++) {
                if (!this.inputFields[i].valid) {
                    return;
                }
            }

            this.loading = true;

            let links = [];

            for (let i = 0, j = this.inputFields.length; i < j; i++) {
                const link = this.inputFields[i].value;
                links.push(link);
            }

            let http = axios.create();
            http.put(this.apiUrl + '/manage-clickandbuys/links', {
                links: links,
            })
                .then(() => {
                    this.error = null;
                    this.success = true;
                    this.loading = false;

                    this.$emit('updated');
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.delete-icon {
    margin-top: 11px;
}
</style>
